export default __webpack_public_path__ + "static/media/logbook.fcdc5f21.png";